import React, { Suspense } from 'react'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'
import RevampedFaberCustomerDashboard from 'pages/Customers/vendor/Faber/otpackComponents/RevampedFaberCustomerDashboard'

export default function FaberOtpDashboard() {
  return (
    <>
      <Suspense fallback={<LayoutSkeleton />}>
        <RevampedFaberCustomerDashboard />
      </Suspense>
    </>
  )
}
